import React from 'react';
import { Table } from 'semantic-ui-react'
import Moment from 'moment';
import { Link } from 'react-router-dom';

import ClaimsStatusLabel from '../../claims/status_label';

const RecordResultListItem = (props) => {
    const {
        id,
        case_id,
        claim_id,
        created_at,
        claim_status
    } = props.claim;
    return (
        <Table.Row key={id}>
            <Table.Cell>
                {claim_id}
            </Table.Cell>
            <Table.Cell>
                <Link to={`/app/database/case/${case_id}`}>
                    {case_id}
                </Link>
            </Table.Cell>
            <Table.Cell>
                <ClaimsStatusLabel status={claim_status} />
            </Table.Cell>
            <Table.Cell>
                {Moment(created_at).format('DD/MM/YYYY HH:mm')}
            </Table.Cell>
        </Table.Row>
    );
}

export default RecordResultListItem;